import { ResponseBase } from '../response-base.model';
import {Seccion} from './seccion'

export class TipoSeccion extends ResponseBase {

    seccion: number;
    ponderacion:number
}
